import { ID } from './../models/ID.model';
import { FastWarranty } from './../models/fast-warranty.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class FastWarrantiesService {

    constructor(
        private http: HttpClient
    ) { }

    newFastWarranty(data: FastWarranty) {
        return this.http.post<FastWarranty>(`/garantias-rapidas`, data);
    }

    getFastWarranties(page: number, itemsPerPage: number) {
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        return this.http.get<FastWarranty[]>(`/garantias-rapidas`, { headers, observe: 'response' });
    }

    deleteFastWarranty(id: ID) {
        return this.http.delete<FastWarranty>(`/garantias-rapidas/${id}`);
    }
}
